import {
  AlertTriangle,
  DollarSign,
  PackageCheck,
} from 'lucide-react';

import { formatMoney } from '../../../../utils/decimalValue';

interface InventorySummaryProps {
  visibleCount: number;
  lowStockCount: number;
  totalValue: number | string;
  lowStockSelected: boolean;
  onLowStockClick: () => void;
}

const InventorySummary = ({
  visibleCount,
  lowStockCount,
  totalValue,
  lowStockSelected,
  onLowStockClick,
}: InventorySummaryProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 border-b border-stroke bg-gray-2/40 p-5 dark:border-strokedark dark:bg-boxdark-2/30 sm:grid-cols-3 sm:px-7">
      <article className="rounded-xl border border-stroke bg-white p-4 shadow-card-2 dark:border-strokedark dark:bg-boxdark dark:shadow-none">
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-bodydark2">
          <PackageCheck className="h-4 w-4 text-primary" />
          Registros mostrados
        </p>

        <p className="mt-2 text-2xl font-bold text-black dark:text-white">
          {visibleCount.toLocaleString('es-SV')}
        </p>
      </article>

      <button
        type="button"
        onClick={onLowStockClick}
        className={`
          rounded-xl
          border
          bg-white
          p-4
          text-left
          shadow-card-2
          transition-all
          duration-200
          hover:border-warning/60
          hover:bg-warning/5
          focus:outline-none
          focus:ring-2
          focus:ring-warning/20
          dark:bg-boxdark
          dark:shadow-none
          ${
            lowStockSelected
              ? 'border-warning ring-1 ring-warning/40'
              : 'border-stroke dark:border-strokedark'
          }
        `}
      >
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-bodydark2">
          <AlertTriangle className="h-4 w-4 text-warning" />
          Stock bajo
        </p>

        <p className="mt-2 text-2xl font-bold text-warning">
          {lowStockCount.toLocaleString('es-SV')}
        </p>
      </button>

      <article className="rounded-xl border border-stroke bg-white p-4 shadow-card-2 dark:border-strokedark dark:bg-boxdark dark:shadow-none">
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-bodydark2">
          <DollarSign className="h-4 w-4 text-success" />
          Valor estimado
        </p>

        <p className="mt-2 text-2xl font-bold text-black dark:text-white">
          {formatMoney(totalValue)}
        </p>
      </article>
    </div>
  );
};

export default InventorySummary;